<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="catalogGrid"></action-toolbar-count>
            <action-toolbar-search name="itemCatalogSearch" [(ngModel)]="catalogGrid.filter"></action-toolbar-search>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid
            id="itemCatalogGrid"
            #itemCatalogGrid
            class="pf-catalog-grid"
            (initialized)="catalogGrid.initialize(itemCatalogGrid)"
            (destroy)="catalogGrid.destroy()"
            [itemsSource]="catalogGrid.view"
            style="height: 320px"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Item'" [binding]="'itemValue'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Categories'" [binding]="'categories'" [width]="180"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Sources'" [binding]="'sources'" [width]="140"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Equipment Count'" [binding]="'equipmentCount'" [width]="130"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Records'" [binding]="'recordCount'" [width]="90"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>

<div class="row page-header mt-3">
    <div class="col-12">
        <h4>
            @if (selectedItem()) {
                Equipment using {{ selectedItem() }}
            } @else {
                Select a part or fluid above to see equipment
            }
        </h4>
    </div>
</div>
<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="equipmentGrid"></action-toolbar-count>
            <action-toolbar-search name="itemEquipmentSearch" [(ngModel)]="equipmentGrid.filter"></action-toolbar-search>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid
            id="itemEquipmentGrid"
            #itemEquipmentGrid
            class="pf-detail-grid"
            appAutoSize
            (initialized)="equipmentGrid.initialize(itemEquipmentGrid)"
            (destroy)="equipmentGrid.destroy()"
            [itemsSource]="equipmentGrid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="120">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    <a
                        [routerLink]="['/equipment/parts-fluids-lookup']"
                        [queryParams]="{ tab: 'equipment', equipment: cell.item.equipment }"
                        (click)="selectedEquipmentChange.emit(cell.item.equipment)"
                        >{{ cell.item.equipment }}</a
                    >
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Description'" [binding]="'equipmentDescription'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Source'" [binding]="'source'" [width]="100">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    <span class="pf-source-badge" [class.pf-source-vista]="cell.item.source === 'Vista'" [class.pf-source-webapps]="cell.item.source === 'WebApps'">
                        {{ cell.item.source }}
                    </span>
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="110"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Sub-Category'" [binding]="'subCategory'" [width]="140"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Item'" [binding]="'itemLabel'" [width]="140"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Qty'" [binding]="'quantity'" [width]="70"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Details'" [binding]="'details'" [width]="'*'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
